// extracted by mini-css-extract-plugin
module.exports = {"animation":"Animation_animation__-rVIG","lottie":"Animation_lottie__3oyMN"};